import { RefObject } from 'react';
import { StateCreator } from 'zustand';

import { CommonStoreType, License, TechInfoState } from '../types';
import { infoProject as fetchInfoProject } from '@/api/common';
import { NamesSteps } from '@/helpers/auth';
import { getCookie, getCurrentCurrencyData } from '@/helpers/common';
import { DEFAULT_COUNTRIES } from '@/helpers/country';
import {
  DEFAULT_CURRENCIES,
  getCurrenciesByCountry,
  getCurrenciesByLicense,
} from '@/helpers/currency';
import { isPromoAvailableDate } from '@/helpers/dateTime';
import { COUNTRY_CODE_HEADER } from '@/helpers/variables';

export const useTechInfoSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  TechInfoState
> = (set, getState) => {
  return {
    pendingStore: true,
    isMobileDevice: false,
    serverError: null,
    gameOpenBackUrl: null,

    countries: DEFAULT_COUNTRIES,
    countryCode: getCookie(COUNTRY_CODE_HEADER) || undefined,
    project: null,
    projectPending: false,
    currentRegistrationStep: NamesSteps.PRIMARY_INFORMATION,
    isAdditionalUserDataForm: false,
    toggleAdditionalUserDataForm: () => {
      const { isAdditionalUserDataForm } = getState();
      set({ isAdditionalUserDataForm: !isAdditionalUserDataForm });
    },

    currencies: DEFAULT_CURRENCIES,
    enableCurrencies: DEFAULT_CURRENCIES,
    formatAmountByCurrency: (amount: number, currency: string) => {
      const store = getState();

      return getCurrentCurrencyData(amount, currency, store.currencies).amount;
    },

    currencyConversion: (amount: number, currency: string) => {
      const store = getState();
      return getCurrentCurrencyData(amount, currency, store.currencies)
        .currency;
    },

    tabBarHeight: 0,
    handleTabBarHeight: (ref: RefObject<HTMLDivElement>) => {
      if (ref === null) return;
      ref.current?.clientHeight
        ? set({ tabBarHeight: ref.current?.clientHeight })
        : set({ tabBarHeight: 0 });
    },

    setCountryCodeData: (isEstonia: boolean) => {
      try {
        const { currencies, countryCode } = getState();

        if (!countryCode) return;

        const currenciesByCountry = getCurrenciesByCountry(
          currencies,
          countryCode
        );
        const currenciesByLicense = getCurrenciesByLicense(
          currenciesByCountry,
          isEstonia ? License.EE : License.CW
        );
        set({ enableCurrencies: currenciesByLicense });
      } catch (error) {
        console.log(error);
      }
    },
    fetchInfoProject: async () => {
      try {
        set({ projectPending: true });
        const { data } = await fetchInfoProject();
        set({ project: data || null, projectPending: false });
      } catch (error) {
        console.log(error);
      } finally {
        set({ projectPending: false });
      }
    },
    authProvidersOptions: [],
    pendingAuthProvidersOptions: false,
  };
};
